import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DashboardState {
  refreshInterval: number;
  selectedTimeRange: string;
  isAutoRefresh: boolean;
  activeAlerts: number;
  systemHealth: number;
}

const initialState: DashboardState = {
  refreshInterval: 60000, // 1 minute
  selectedTimeRange: '1h',
  isAutoRefresh: true,
  activeAlerts: 0,
  systemHealth: 100,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setRefreshInterval: (state, action: PayloadAction<number>) => {
      state.refreshInterval = action.payload;
    },
    setTimeRange: (state, action: PayloadAction<string>) => {
      state.selectedTimeRange = action.payload;
    },
    toggleAutoRefresh: (state) => {
      state.isAutoRefresh = !state.isAutoRefresh;
    },
    setActiveAlerts: (state, action: PayloadAction<number>) => {
      state.activeAlerts = action.payload;
    },
    setSystemHealth: (state, action: PayloadAction<number>) => {
      state.systemHealth = action.payload;
    },
  },
});

export const { setRefreshInterval, setTimeRange, toggleAutoRefresh, setActiveAlerts, setSystemHealth } = dashboardSlice.actions;
export default dashboardSlice.reducer;